
export default function Image({width,height,src='',alt='',className,style}){
	let img_style = {...style}
	if(width){
		img_style.width = width
	}
	if(height){
		img_style.height = height
	}

	return <img className={className} src={src} alt={alt} style={img_style}/>
}
